<template>
  <span @click="onClick">{{ showRelative ? time.ago : time.text }} <i v-if="!noIcon" class="las la-clock"></i></span>
</template>

<script>

import { DateTime } from 'luxon'

export default {
  name: 'TimeAgo',
  props: {
    timestamp: { type: [Number, String], required: false },
    static: { type: Boolean, required: false, default: false },
    newRelative: { type: Boolean, required: false, default: false },
    noClick: { type: Boolean, required: false, default: false },
    noIcon: { type: Boolean, required: false, default: false }
  },
  data () {
    return {
      showRelative: true,
      updateMarker: 1,
      forceStatic: false
    }
  },
  methods: {
    onClick ($event) {
      if (this.noClick) {
        return
      }
      this.showRelative = !this.showRelative
      $event.stopPropagation()
    }
  },
  computed: {
    time () {
      var vm = this
      var datetime = vm.updateMarker ? null : null
      if (vm.timestamp) {
        if (typeof vm.timestamp === 'number') {
          datetime = DateTime.fromMillis(vm.timestamp)
        } else if (typeof vm.timestamp === 'string') {
          datetime = DateTime.fromISO(vm.timestamp)
        }
      }
      if (datetime) {
        return {
          datetime: datetime,
          ago: datetime.toRelative(),
          text: datetime.toLocaleString(DateTime.DATETIME_SHORT)
        }
      } else {
        return { datetime: null, ago: '--', text: '--' }
      }
    }
  },
  mounted () {
    var vm = this

    var forceStatic = vm.static

    if (vm.newRelative && vm.time.datetime) {
      var millisDiff = Math.abs(vm.time.datetime.diffNow().toMillis())
      if (millisDiff > (1000 * 60 * 60 * 24 * 3)) {
        vm.showRelative = false
        forceStatic = true
      }
    }

    if (!forceStatic) {
      vm.interval = setInterval(() => {
        vm.updateMarker = Math.random()
      }, 5000)
    }
  },
  beforeDestroy () {
    if (this.interval) {
      clearInterval(this.interval)
    }
  },
  watch: {
    timestamp: function () {
      var vm = this
      vm.updateMarker = Math.random()
    }
  }
}
</script>
